/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileLocation_tradeFirm = {
    readonly serviceId: string | null;
    readonly publicProfile: {
        readonly address: {
            readonly city: string | null;
            readonly state: string | null;
            readonly country: string | null;
            readonly zipCode: string | null;
        } | null;
    } | null;
    readonly " $refType": "ProfileLocation_tradeFirm";
};
export type ProfileLocation_tradeFirm$data = ProfileLocation_tradeFirm;
export type ProfileLocation_tradeFirm$key = {
    readonly " $data"?: ProfileLocation_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileLocation_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProfileLocation_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "address",
          "storageKey": null,
          "args": null,
          "concreteType": "Address",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "city",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "state",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "country",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "zipCode",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '03a4e5298d9737070acc0cf3cb10aa9a';
export default node;
